import WebMap from "@arcgis/core/WebMap";

const addBaseTemplateLayers = async ({ baseTemplate, map }): Promise<void> => {
  if (baseTemplate?.useBaseTemplate) {
    const baseTemplateMap = await new WebMap({
      portalItem: { id: baseTemplate.mapId },
    })
    .load()
    .then((map)=>map)
    .catch((error)=>{
      window.location.href = `${process.env.REACT_APP_BASE_DOMAIN_URL}/403`
    })

    const resultLayers = await Promise.allSettled(
      baseTemplateMap.allLayers.map(async (layer) => {
        return layer.load()})
    )

    const loadedLayers=[]
    resultLayers.forEach(result=>{
      if(result.status==='fulfilled'){
        loadedLayers.push(result.value)
      } 
    })
    const resultTables = await Promise.allSettled(
      baseTemplateMap.allTables.map(async (table) => {
        return table.load();
      })
    );

    const loadedTables=[]
    resultTables.forEach(result=>{
      if(result.status==='fulfilled'){
        loadedTables.push(result.value)
      } 
    })

    baseTemplate.layerIdsRemove.forEach((id) => {
      loadedTables.forEach(async (table) => {
        if (table?.layerId === id) {
          let parent = table.parent;
          parent.remove(table);
        }
      });
      loadedLayers.forEach(async (layer) => {
        if (layer?.type === "feature" && layer?.layerId === id) {
          let parent = layer.parent;
          parent.remove(layer);
          if (parent.allLayers.length === 0) {
            parent.parent.remove(parent);
          }
        }
        if (layer?.type === "group") {
        }
        if (layer?.type === "map-image") {
          layer?.allSublayers.forEach(async (sublayer) => {
            if (sublayer.id === id) {
              let parent = layer.parent;
              parent.remove(layer);
              if (parent.allLayers.length === 0) {
                parent.parent.remove(parent);
              }
            }
          });
        }
      });
    });

    map.addMany(baseTemplateMap.layers,-1);

    map.tables.addMany(baseTemplateMap.tables,-1);
    if(map?.applicationProperties?.viewing?.search?.layers){
    map.applicationProperties.viewing.search.layers.addMany(
      baseTemplateMap.applicationProperties.viewing.search.layers
    );
    }
    if(map?.applicationProperties?.viewing?.search?.layers){
    map.applicationProperties.viewing.search.tables.addMany(
      baseTemplateMap.applicationProperties.viewing.search.tables
    );
    }
  }
};

export default addBaseTemplateLayers;
